export default __webpack_public_path__ + "static/media/grimcorruption3.0be819e2.png";